import css from './business-map.module.scss';
import { ReactComponent as ListIcon } from 'src/assets/map/list-icon.svg';
import { ReactComponent as MapIcon } from 'src/assets/map/map.svg';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { MapCategory } from './types';

interface MapFilterProps {
  categories: MapCategory[];
  selectedCategory: string;
  onFilter: (text: string) => void;
  isMobile?: boolean;
  showCards: boolean;
  switchView: () => void;
}

function MapCategoryFilter({
  categories,
  selectedCategory,
  onFilter,
  isMobile = false,
  showCards,
  switchView
}: Readonly<MapFilterProps>) {
  const switchIcon = (
    <ToggleButtonGroup value={showCards} exclusive onChange={switchView} aria-label='toggle view'>
      <ToggleButton
        title='Мапа'
        value={false}
        aria-label='table view'
        sx={{
          backgroundColor: 'white',
          '&.MuiToggleButton-root.Mui-selected': {
            backgroundColor: '#f39200'
          }
        }}>
        <MapIcon onClick={switchView} />
      </ToggleButton>
      <ToggleButton
        title='Список'
        value={true}
        aria-label='map view'
        sx={{
          backgroundColor: 'white',
          '&.MuiToggleButton-root.Mui-selected': {
            backgroundColor: '#f39200'
          }
        }}>
        <ListIcon onClick={switchView} />
      </ToggleButton>
    </ToggleButtonGroup>
  );

  return (
    <div className={css.categoryFilter}>
      {isMobile && <div className={css.controls}>{switchIcon}</div>}
      <div className={css.filterBtns}>
        <button className={selectedCategory === '-1' ? css.active : ''} key={'all'} onClick={() => onFilter('-1')}>
          <span>Усі</span>
          <ListIcon />
        </button>
        {categories.map((category: MapCategory) => (
          <button
            className={selectedCategory === category.id ? css.active : ''}
            key={category.name}
            onClick={() => onFilter(category.id)}>
            <span>{category.name}</span>
            <img src={category.filterImg} alt={category.name}></img>
          </button>
        ))}
      </div>
    </div>
  );
}

export default MapCategoryFilter;
